import "./Ellipsis.scss";

import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import EllipsisDirectiveController from "./EllipsisDirectiveController";

export default class EllipsisDirective implements IDirective {
    public bindToController = {
        mmEllipsis: "<",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public restrict = "A";

    public scope = {};

    constructor() {
        this.controller = EllipsisDirectiveController;
    }
}

module("mmGui").directive("mmEllipsis", () => new EllipsisDirective());
